"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _userInfo = require("hub-http/userInfo");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIEditorPage = _interopRequireDefault(require("UIComponents/page/UIEditorPage"));

var _UIToolBar = _interopRequireDefault(require("UIComponents/nav/UIToolBar"));

var _UIToolBarGroup = _interopRequireDefault(require("UIComponents/nav/UIToolBarGroup"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _UIListingPage = _interopRequireDefault(require("UIComponents/page/UIListingPage"));

var _UIHeader = _interopRequireDefault(require("UIComponents/layout/UIHeader"));

var _Config = _interopRequireDefault(require("./api/Config"));

var _SettingsNav = _interopRequireDefault(require("./components/SettingsNav"));

var _ReturnLinkHelper = _interopRequireDefault(require("./utils/ReturnLinkHelper"));

var _BackLink = _interopRequireDefault(require("./components/BackLink"));

var localConfig = _Config.default.getLocal();

var CONTEXTUAL_NAVIGATION_GATE = 'settings-ui:contextual-navigation';
var CONTEXTUAL_NAVIGATION_SCOPE = 'settings-contextual-navigation-access';

var SettingsPage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SettingsPage, _Component);

  function SettingsPage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SettingsPage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SettingsPage).call(this, props));
    _this.state = {
      config: []
    };

    _ReturnLinkHelper.default.hydrate();

    return _this;
  }

  (0, _createClass2.default)(SettingsPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (localConfig) {
        this.setState({
          config: localConfig
        });
      }

      _Config.default.get().then(function (config) {
        _this2.setState({
          config: config
        });
      });
    }
  }, {
    key: "hasContextualNavigation",
    value: function hasContextualNavigation() {
      var _userInfoSync = (0, _userInfo.userInfoSync)(),
          gates = _userInfoSync.gates,
          scopes = _userInfoSync.user.scopes;

      return gates.includes(CONTEXTUAL_NAVIGATION_GATE) || scopes.includes(CONTEXTUAL_NAVIGATION_SCOPE);
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return _react.default.createElement(_UIToolBar.default, {
        use: "dark"
      }, _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement(_BackLink.default, null)), _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: "settings-ui-nav.page-title"
      }))), _react.default.createElement(_UIToolBarGroup.default, null));
    }
  }, {
    key: "renderSettingsNav",
    value: function renderSettingsNav() {
      var config = this.state.config;
      var _this$props = this.props,
          pathname = _this$props.pathname,
          settingsApp = _this$props.settingsApp,
          onClickHandler = _this$props.onClickHandler,
          track = _this$props.track;
      return _react.default.createElement(_SettingsNav.default, {
        pathname: pathname,
        settingsApp: settingsApp,
        onClickHandler: onClickHandler,
        config: config,
        track: track
      });
    }
  }, {
    key: "renderContextualNav",
    value: function renderContextualNav() {
      return _react.default.createElement(_UIEditorPage.default, {
        headerComponent: this.renderHeader(),
        "data-reagan-test": "settings-page",
        sidebarComponent: _react.default.createElement("div", {
          style: {
            width: 300,
            padding: '1.25em'
          },
          className: "m-left-5"
        }, this.renderSettingsNav()),
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "settings-ui-nav.page-title"
        })
      }, this.props.children);
    }
  }, {
    key: "renderDefaultNav",
    value: function renderDefaultNav() {
      return _react.default.createElement(_UIListingPage.default, {
        stickySidebar: true,
        headerComponent: _UIHeader.default,
        "data-reagan-test": "settings-page",
        sidebarComponent: this.renderSettingsNav(),
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "settings-ui-nav.page-title"
        })
      }, this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      return this.hasContextualNavigation() ? this.renderContextualNav() : this.renderDefaultNav();
    }
  }]);
  return SettingsPage;
}(_react.Component);

SettingsPage.propTypes = {
  children: _react.PropTypes.node.isRequired,

  /**
   * The current pathname, either window.location.pathname or
   * with react-router-redux: state.routing.locationBeforeTransitions.basename
   *  + state.routing.locationBeforeTransitions.pathname;
   */
  pathname: _react.PropTypes.string.isRequired,

  /**
   * Optional handler for link clicks. Gets passed the event and the NavItem that
   * is clicked. The handler provided should, in most cases, match links by href
   * to implement custom routing for internal links and let external link clicks
   * propagate normally.
   */
  onClickHandler: _react.PropTypes.func,

  /**
   * The name of the application that the nav is being used in. This will be attached
   * to usage tracking events to make it easier to distinguish events created by
   * indepedent settings deployables
   */
  settingsApp: _react.PropTypes.string,

  /**
   * A track function that gets called with
   * events from settings-ui-nav/events.yaml
   */
  track: _react.PropTypes.func.isRequired
};
var _default = SettingsPage;
exports.default = _default;
module.exports = exports.default;